var exports = {
  "e6": "AddFavoriteChannelModal.module__selectContainer___RHlreT",
  "yc": "AddFavoriteChannelModal.module__checkboxRow___RHlreT",
  "Dq": "AddFavoriteChannelModal.module__checkboxText___RHlreT",
  "gs": "AddFavoriteChannelModal.module__scrollerContainer___RHlreT",
  "o5": "AddFavoriteChannelModal.module__channelList___RHlreT",
  "p$": "AddFavoriteChannelModal.module__emptyState___RHlreT",
  "Km": "AddFavoriteChannelModal.module__categoryHeader___RHlreT",
  "WG": "AddFavoriteChannelModal.module__channelRow___RHlreT",
  "uM": "AddFavoriteChannelModal.module__channelIconContainer___RHlreT",
  "p": "AddFavoriteChannelModal.module__channelIcon___RHlreT",
  "HA": "AddFavoriteChannelModal.module__channelName___RHlreT",
  "tN": "AddFavoriteChannelModal.module__channelActions___RHlreT",
};

module.exports = exports;
